export default "__VITE_ASSET__C8b4rOaO__"